/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ref_number_medium'
export default icon
